"use strict";Object.defineProperty(exports,"__esModule",{value:!0});exports.removeFileExtension=e=>e.replace(/\.[^.]*$/,"")||e;
//# sourceMappingURL=remove-file-extension.js.map
